var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInbox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.381,
    height: 22.381,
    viewBox: "0 0 22.9 22.381",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a-i-nbx{fill:none;stroke:#232323;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1406.75 -1085.75)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a-i-nbx",
    d: "M1407.5,1101.5h5.565a.936.936,0,0,1,.887.724,2.725,2.725,0,0,0,2.626,2h2.724a2.725,2.725,0,0,0,2.626-2,.936.936,0,0,1,.887-.724h5.565",
    transform: "translate(0 -1.382)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a-i-nbx",
    d: "M1411.5,1097.394V1086.5h10.866l2.752,2.78v8.114",
    transform: "translate(-0.369)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a-i-nbx",
    x2: 5.447,
    transform: "translate(1415.217 1091.493)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a-i-nbx",
    x2: 5.447,
    transform: "translate(1415.217 1095.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a-i-nbx",
    d: "M1427.473,1092.5l.908,8.171v5.447a1.815,1.815,0,0,1-1.816,1.816h-17.249a1.815,1.815,0,0,1-1.816-1.816v-5.447l.908-8.171",
    transform: "translate(0 -0.553)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/inbox.b9d13162.svg";
export { ForwardRef as ReactComponent };